import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home relative h-full" }
const _hoisted_2 = {
  key: 1,
  class: "absolute z-1 inset-0 flex items-center justify-center"
}
const _hoisted_3 = { class: "text-gray-500 w-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoneOverview = _resolveComponent("DoneOverview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.store?.state?.OrderStore?.done.length)
      ? (_openBlock(), _createBlock(_component_DoneOverview, {
          key: 0,
          orders: _ctx.store?.state?.OrderStore?.done
        }, null, 8, ["orders"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("order.empty")), 1)
        ]))
  ]))
}